import { render, staticRenderFns } from "./AccordionCell.global.vue?vue&type=template&id=3dac89b8&scoped=true&lang=pug&"
import script from "./AccordionCell.global.vue?vue&type=script&lang=ts&"
export * from "./AccordionCell.global.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionCell.global.vue?vue&type=style&index=0&id=3dac89b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dac89b8",
  null
  
)

export default component.exports